import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Badge, TextBody, Tooltip } from "@opensea/ui-kit";
import { EnergySavingsLeaf } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { ReceiptRowDisplay } from "../../../../components/Receipt";
import { findActiveDropStage } from "../utils";
import { MintTableRowCollectionFragment, MintTableRowDropFragment } from "./MintTableRow.fragment";
export const MintTableRow = t0 => {
  const $ = _c(2);
  const {
    item: itemKey,
    context
  } = t0;
  let t1;
  if ($[0] !== itemKey.collection) {
    t1 = readFragment(MintTableRowCollectionFragment, itemKey.collection);
    $[0] = itemKey.collection;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  const drop = readFragment(MintTableRowDropFragment, itemKey.drop);
  const t = useTranslations("wallet.MintTableRow");
  const activeStage = findActiveDropStage(drop);
  const price = activeStage.eligiblePrice ?? activeStage.price;
  const erc721Quantity = context?.tokenInputs.reduce(_temp, 0) ?? 0;
  return drop.__typename === "Erc1155SeaDropV2" ? context?.tokenInputs.map(tokenInput => {
    const token = drop.tokenMintDetails.find(t_0 => String(t_0.tokenId) === tokenInput.tokenId);
    const stageTokenData = activeStage.tokenIdMapping?.get(tokenInput.tokenId);
    return <ReceiptRowDisplay item={{
      imageUrl: token?.imageUrl || collection.imageUrl || null,
      title: <CollectionLockup collection={collection}><CollectionLockupContent><CollectionLockupTitle /></CollectionLockupContent></CollectionLockup>,
      extra: tokenInput.quantity > 1 ? <Tooltip content={t("quantity", {
        count: tokenInput.quantity
      })}><Badge icon={EnergySavingsLeaf}>{tokenInput.quantity}</Badge></Tooltip> : null,
      description: token?.groupName && <TextBody color="text-secondary">{token.groupName}: {token.groupValue}</TextBody>
    }} key={token?.tokenId} price={stageTokenData?.price ? {
      unit: stageTokenData.price.token.unit,
      symbol: stageTokenData.price.token.symbol,
      usd: stageTokenData.price.usd
    } : undefined} quantity={tokenInput.quantity} />;
  }) : <ReceiptRowDisplay item={{
    imageUrl: collection.imageUrl || null,
    title: <CollectionLockup collection={collection}><CollectionLockupContent><CollectionLockupTitle /></CollectionLockupContent></CollectionLockup>,
    extra: erc721Quantity > 1 ? <Tooltip content={t("quantity", {
      count: erc721Quantity
    })}><Badge icon={EnergySavingsLeaf}>{erc721Quantity}</Badge></Tooltip> : null
  }} price={price ? {
    unit: price.token.unit,
    symbol: price.token.symbol,
    usd: price.usd
  } : undefined} quantity={context?.tokenInputs.reduce(_temp2, 0)} />;
};
function _temp(sum, item) {
  return sum + item.quantity;
}
function _temp2(sum_0, item_0) {
  return sum_0 + item_0.quantity;
}